import AlertBox from "components/global/AlertBox";
import styled from "styled-components";
import googleIcon from "assets/icons/googleIcon.svg";
import { initialState } from "api/rootReducer";
import appleIcon from "assets/icons/appleIcon.svg";
import instagramIcon from "assets/icons/instagramDefault.svg";
import emailIcon from "assets/icons/emailIcon.svg";
import facebookIcon from "assets/icons/facebookIconCircle.svg";

const Wrapper = styled.div`
  height: 100dvh;

  .content {
    background-color: var(--white);
    padding: 96px 24px;
    position: relative;
    width: 480px;
    margin: auto;

    .header {
      display: flex;
      justify-content: space-between;
    }

    .description {
      color: #4e4b66;
    }
  }

  .forgotPassword {
    font-size: 14px;
    line-height: 20px;
  }

  .validators {
    gap: 8px;
    display: grid;
    grid-template-columns: 1fr 1fr;

    .invalid {
      color: var(--grey_8);
    }
  }

  .resend_code_container {
    display: block;
    font-size: 14px;
    font-weight: 450;
    color: var(--body_text);
    margin: 16px 0 24px;

    button {
      color: var(--secondary);
      font-size: 14px;
      font-weight: 450;
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    overflow: auto;

    .content {
      padding: 24px;
      width: 100%;

      h3 {
        font-size: 20px;
        line-height: 28px;
      }

      .description {
        font-size: 14px;
        font-style: normal;
        font-weight: 450;
      }
    }

    .title-1 {
      font-size: 14px;
      line-height: 20px;

      a {
        font-size: 14px;
      }
    }

    label {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
    }

    .legal {
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 18px;
    }

    .linkBottomRight {
      width: calc(100% - 48px);
      margin: auto;
      right: unset;

      a {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .signInText {
    color: var(--secondary);
  }
`;

export const AuthProviderButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  background-color: var(--white);
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  transition: var(--transition_default);
  margin-bottom: 12px;
  width: 100%;
  padding: 12px;
  color: var(--grey_1) !important;

  &:last-of-type {
    margin-bottom: 24px;
  }

  &:hover {
    background-color: var(--background);
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  position: relative;

  .text {
    position: relative;
    padding: 6px;
    background-color: var(--white);
    z-index: 1;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--grey_10);
  }
`;

export const authProviders = [
  // {
  //   name: "instagram",
  //   buttonText: "Continue with Instagram Business",
  //   target: `${initialState.api_host}auth/instagram`,
  //   icon: instagramIcon,
  // },
  // {
  //   name: "facebook",
  //   buttonText: "Continue with Facebook",
  //   target: `${initialState.api_host}auth/facebook`,
  //   icon: facebookIcon,
  // },
  {
    name: "google",
    buttonText: "Continue with Google",
    target: `${initialState.api_host}auth/google`,
    icon: googleIcon,
  },
  {
    name: "apple",
    buttonText: "Continue with Apple",
    target: `${initialState.api_host}auth/apple`,
    icon: appleIcon,
  },
  {
    name: "email",
    buttonText: "Continue with Email",
    target: "/sign-up/email",
    icon: emailIcon,
  },
];

const AuthLayout = ({ children }) => {
  return (
    <Wrapper>
      <AlertBox />
      <div className="content">{children}</div>
    </Wrapper>
  );
};

export default AuthLayout;
